module.exports = __webpack_public_path__ + "static/media/store.8c723a0e.png";